var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    height: "auto",
    viewBox: "0 0 128 128",
    overflow: "hidden",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.863
    },
    fill: "current",
    stroke: "current",
    d: "M58.5 13.5c1.195.366 1.861 1.199 2 2.5a59.84 59.84 0 0 0-4 15.5 29.65 29.65 0 0 0 3.5 9 4.452 4.452 0 0 0 1.5-2 127.734 127.734 0 0 1-2-9c1.67-4.726 3.337-9.392 5-14 2.248 4.83 2.582 9.83 1 15a100.719 100.719 0 0 1 1.5 8c2.594-5.122 3.427-10.455 2.5-16 1.468-4.847 2.968-4.514 4.5 1 .168 7.688.668 15.355 1.5 23 1.299-.59 2.132-1.59 2.5-3l2-8c3.923 4.462 4.59 9.462 2 15-2.332 6.006-5.666 11.34-10 16-.777 2.93-.61 5.763.5 8.5-1.842 2.696-2.175 5.53-1 8.5 3.447 1.14 6.28 3.14 8.5 6l15-11c-.245 4.188-1.412 8.188-3.5 12l1.5 1c7.555-2.216 15.055-3.55 22.5-4a247.734 247.734 0 0 1-13 13.5 43.39 43.39 0 0 1-8 2c1.785 1.163 3.785 1.83 6 2 1.134 1.016.801 1.683-1 2-7.947 3.174-15.947 3.674-24 1.5a82.042 82.042 0 0 0-10.5 3 45.67 45.67 0 0 1-10-4 16.41 16.41 0 0 1-7 3 358.656 358.656 0 0 1-18.5-3.5c2.411-1.583 5.078-2.583 8-3a153.716 153.716 0 0 1-13-3l-14-14a205.81 205.81 0 0 1 29 6.5l1-1a257.005 257.005 0 0 0-10-19l1-1a627.088 627.088 0 0 0 18.5 15c2.185-2.04 4.685-3.374 7.5-4a35.159 35.159 0 0 1 2-14c-.947-1.9-2.447-3.234-4.5-4-2.771-6.782-7.105-12.45-13-17-.374-4.83.96-9.164 4-13a10.253 10.253 0 0 1 1.5 4 21.332 21.332 0 0 0-1 7c2.1-.023 3.933.644 5.5 2l1.5-1a182.937 182.937 0 0 0-3-16.5c1.43-6.481 4.096-12.314 8-17.5Zm3 75c8.708-.158 14.375 3.842 17 12-9.143 3.555-18.476 3.889-28 1-1.163-2.05-.996-4.05.5-6 2.7-3.752 6.2-6.085 10.5-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.663
    },
    fill: "current",
    stroke: "current",
    d: "M88.5 62.5c2.036 4.017 2.87 8.35 2.5 13a29.946 29.946 0 0 0-7 6c.96-6.399 2.46-12.732 4.5-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.649
    },
    fill: "current",
    stroke: "current",
    d: "M36.5 65.5c2.436-1.072 4.602-.405 6.5 2 1.32 3.27 1.987 6.603 2 10-5.08-2.555-7.913-6.555-8.5-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.572
    },
    fill: "current",
    stroke: "current",
    d: "M18.5 78.5c2.747-.313 5.413.02 8 1a37.12 37.12 0 0 0 2 4.5c-1 .667-2 .667-3 0-2.836-1.391-5.17-3.224-7-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.54
    },
    fill: "current",
    stroke: "current",
    d: "M102.5 79.5c2.597.143 4.931.977 7 2.5A147.687 147.687 0 0 0 99 86.5c.579-2.492 1.746-4.825 3.5-7Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeize);
export default __webpack_public_path__ + "static/media/seize.152b03df.svg";
export { ForwardRef as ReactComponent };